import {Suspense} from 'react'
import {useLazyLoadQuery} from 'react-relay'
import {graphql} from 'relay-runtime'
import {SubscriptionSection} from './SubscriptionSection'
import type {LazySubscriptionSectionQuery} from './__generated__/LazySubscriptionSectionQuery.graphql'
import {LABELS} from '../../constants'

import {BellIcon} from '@primer/octicons-react'
import {Box, Button, Text} from '@primer/react'
import {ReadonlySectionHeader} from './ReadonlySectionHeader'
import {Section} from './Section'

type LazySubscriptionSectionProps = {
  issueId: string
}

export function LazySubscriptionSection(props: LazySubscriptionSectionProps) {
  return (
    <Suspense fallback={<SubscriptionSectionFallback />}>
      <LazyLazySubscriptionSectionFetched {...props} />
    </Suspense>
  )
}

function LazyLazySubscriptionSectionFetched({issueId}: LazySubscriptionSectionProps) {
  const {node} = useLazyLoadQuery<LazySubscriptionSectionQuery>(
    graphql`
      query LazySubscriptionSectionQuery($issueId: ID!) {
        node(id: $issueId) {
          ... on Issue {
            ...SubscriptionSectionFragment
          }
        }
      }
    `,
    {issueId},
    {fetchPolicy: 'store-only'},
  )

  if (!node) return null

  return <SubscriptionSection issue={node} />
}

function SubscriptionSectionFallback() {
  return (
    <Section sectionHeader={<ReadonlySectionHeader title="Notifications" />}>
      <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', px: 2, pt: 2, alignItems: 'stretch'}}>
        <Button aria-describedby="issue-viewer-subscription-description" leadingVisual={BellIcon}>
          {LABELS.notifications.unsubscribedButton}
        </Button>
        <Text id="issue-viewer-subscription-description" sx={{fontSize: 0, mb: 2, mt: 2, color: 'fg.muted'}}>
          {LABELS.notifications.unsubscribedDescription}
        </Text>
      </Box>
    </Section>
  )
}

try{ LazySubscriptionSection.displayName ||= 'LazySubscriptionSection' } catch {}
try{ LazyLazySubscriptionSectionFetched.displayName ||= 'LazyLazySubscriptionSectionFetched' } catch {}
try{ SubscriptionSectionFallback.displayName ||= 'SubscriptionSectionFallback' } catch {}